import { render, staticRenderFns } from "./CardFormTab.vue?vue&type=template&id=cbcbb62e"
import script from "./CardFormTab.vue?vue&type=script&lang=js"
export * from "./CardFormTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports